import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import useScrollPosition from "../../hooks/useScrollPosition";
import MobileMenu from "./MobileMenu";
import "./Navbar.css";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/programs", label: "Programs" },
  { to: "/trainers", label: "Trainers" },
  { to: "/membership", label: "Membership" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const scrolled = useScrollPosition(40);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <header className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}>
        <div className="navbar__inner container">

          <Link to="/" className="navbar__logo" aria-label="Firm Fit Factory home">
            <img src="/firmlogo.png" alt="" />
            <span></span>  FIRM<span>FIT</span>FACTORY
          </Link>

          <nav className="navbar__links" aria-label="Primary navigation">
            {LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) => `navbar__link ${isActive ? "navbar__link--active" : ""}`}
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="navbar__actions">
            <Link to="/contact" className="btn btn-primary navbar__cta">Join Now</Link>
            <button
              type="button"
              className={`navbar__burger ${menuOpen ? "navbar__burger--open" : ""}`}
              onClick={() => setMenuOpen(true)}
              aria-label="Open menu"
              aria-expanded={menuOpen}
              aria-controls="mobile-menu"
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>
      </header>
      <MobileMenu open={menuOpen} onClose={() => setMenuOpen(false)} links={LINKS} />
    </>
  );
}
